module.exports = __webpack_public_path__ + "img/nu-logo.c538bc2e.png";